module.exports = __webpack_public_path__ + "static/media/tz.83f27e2e.webp";